import React, { Component } from 'react';
import fire from '../fire';
import './UserRanking.css';
import { FormattedMessage } from 'react-intl';

class UserRanking extends Component {

    constructor(props) {
        super(props);
        this.state = {bettingResult: {}};
    }

    componentWillMount(){
        /* Create reference to messages in Firebase Database */
        let gamesRef = fire.database().ref('v1/betting/ranking/' + this.props.user.uid);

        gamesRef.on('value', snapshot => {
            this.setState({bettingResult: snapshot.val()});
        });
    }

    render() {
        let quote = '-';
        let position = '-';
        let points = '-';
        let votes = '-';
        if (this.state.bettingResult && this.state.bettingResult.votes) {
            quote = Math.round(100 / this.state.bettingResult.votes * this.state.bettingResult.points) + '%';
        }
        if (this.state.bettingResult && this.state.bettingResult.position) {
            position = this.state.bettingResult.position + '.';
        }
        if (this.state.bettingResult && this.state.bettingResult.points) {
            points = this.state.bettingResult.points;
        }
        if (this.state.bettingResult && this.state.bettingResult.votes) {
            votes = this.state.bettingResult.votes;
        }
        return (
            <div>
            <div className="user-ranking">
                <div className="user-ranking-row">
                    <div><FormattedMessage id={ 'ranking.user_ranking.position' } defaultMessage={ 'Platz' } /></div>
                    <div>{ position }</div>
                </div>
                <div className="user-ranking-row">
                    <div><FormattedMessage id={ 'ranking.user_ranking.points' } defaultMessage={ 'Punkte' } /></div>
                    <div>{ points }</div>
                </div>
                <div className="user-ranking-row">
                    <div><FormattedMessage id={ 'ranking.user_ranking.votes' } defaultMessage={ 'Tipps' } /></div>
                    <div>{ votes }</div>
                </div>
                <div className="user-ranking-row">
                    <div><FormattedMessage id={ 'ranking.user_ranking.quote' } defaultMessage={ 'Trefferquote' } /></div>
                    <div>{ quote }</div>
                </div>


            </div>
                <div className="user-ranking-rules">
                    <span className="title"><FormattedMessage id={ 'ranking.user_ranking.info.title' } defaultMessage={ 'Spielregeln' } /></span>

                    <p><FormattedMessage id={ 'ranking.user_ranking.info.block1' } defaultMessage={ 'Herzlich Willkommen beim HockeyInfo Tippspiel. Du kannst für alle Spiele der National League auf den Gewinner tippen. Für jeden richtigen Tipp erhältst du einen Punkt gutgeschrieben. Das Spiel läuft während der ganzen Qualifikationsphase. Viel Glück!' } /></p>

                    <p><FormattedMessage id={ 'ranking.user_ranking.info.block2' } defaultMessage={ '* Durch deine Teilnahme erklärst du dich damit einverstanden, dass wir deinen Namen sowie dein Facebook-Profilbild auf der Rangliste publizieren dürfen.' } /></p>

                </div>
            </div>
        );
    }
}

export default UserRanking;


// WEBPACK FOOTER //
// ./src/Ranking/UserRanking.js